import { getCurrentDomain } from '../../../shared/utils/host';

const DEFAULT_COUNTRY = 'UK';

const getCookieLoggerDomain = () => {
  const PROD_MAIN_DOMAIN = 'any.run';
  const PROD_MULTILINGUAL_SECOND_LEVEL_DOMAIN = 'anyrun';

  const PROD_SUB_DOMAIN = 'cookie';
  const TEST_SUB_DOMAIN = 'cookie-logger-test';

  const currentDomain = getCurrentDomain();
  const isProdStage =
    currentDomain === PROD_MAIN_DOMAIN ||
    currentDomain.startsWith(PROD_MULTILINGUAL_SECOND_LEVEL_DOMAIN);

  const domain = isProdStage ? PROD_MAIN_DOMAIN : currentDomain;
  const subDomain = isProdStage ? PROD_SUB_DOMAIN : TEST_SUB_DOMAIN;

  return `${subDomain}.${domain}`;
};

export const determineGeoLocation = async () => {
  try {
    const cookieLoggerDomain = getCookieLoggerDomain();
    const url = `https://${cookieLoggerDomain}/api/geo-location`;

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      body: JSON.stringify({}),
    });

    if (!response || !response.ok || response.status !== 201) {
      throw new Error('Geo location failed');
    }

    const data = await response.json();

    return data;
  } catch (err) {
    return { country: DEFAULT_COUNTRY };
  }
};
